import { gql } from "@apollo/client";

export default gql`
  query getReembedKnowledgeSourcesToContextualRagJob($jobId: ID!){
    getReembedKnowledgeSourcesToContextualRagJob(jobId: $jobId){
        success
        data{
            jobId
            status
            allCustomers
            targetCustomerIds
            totalCustomers
            completedCustomers
            failedCustomers
            remainingCustomers
            processedKnowledgeSources
            processedContents
            reembeddedContents
            skippedContents
            failedContents
            currentCustomerId
            completedCustomerIds
            failedCustomerIds
            failures{
                customerId
                aiKnowledgeSourceId
                aiKnowledgeSourceContentId
                reason
            }
            createdAt
            startedAt
            finishedAt
            updatedAt
        }
        code
        message
    }
}
`
